import React from "react";
import { Redirect, Route } from "react-router-dom";

import { isAccessible, getUserData } from "@utils/commonFunctions";

const PrivateRoute = ({ component: Component, path, authed, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAccessible(path) && getUserData()?.isAgreeTC ? (
        authed === true ? (
          <Component {...props} />
        ) : (
          <Redirect to="/page-not-found" />
        )
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);

export default PrivateRoute;
